export default __webpack_public_path__ + "static/media/ScheduleForASpecialOccasion.e3bc2dd0.svg";